import React from 'react';
import { runStrategies, extractPluginsConfig, fetchEmbedData, themeStrategy, experimentStrategy, } from '@wix/ricos-common';
import { merge } from 'lodash';
import { runViewerStrategies } from './runViewerStrategies';
export const createWixRicosViewer = (RicosViewer) => function WixRicosViewer(props) {
    // eslint-disable-next-line import/no-extraneous-dependencies, @typescript-eslint/no-var-requires
    const { version: wixRicosVersion } = require('@wix/ricos-viewer/package.json');
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { version: ricosVersion } = require('ricos-viewer-next/package.json');
    const { children, biSettings, instance, plugins, theme, wixExperiments, allowLinkPreviewPopover, httpClient, msid, baseUrl, previewMode, content, ...rest } = props;
    const experiments = experimentStrategy(wixExperiments);
    const strategyProps = runStrategies({
        plugins,
        instance,
        biSettings,
        experiments,
        wixRicosVersion,
        ricosVersion,
        httpClient,
        msid,
        viewer: true,
        content,
    });
    const _rcProps = merge(strategyProps, runViewerStrategies(plugins, baseUrl, previewMode), extractPluginsConfig(plugins, strategyProps.helpers));
    return (React.createElement(RicosViewer, { _rcProps: _rcProps, content: content, experiments: strategyProps.experiments, plugins: plugins, theme: themeStrategy(theme), ...(allowLinkPreviewPopover && {
            linkPreviewPopoverFetchData: fetchEmbedData(instance),
        }), ...rest }, children));
};
//# sourceMappingURL=WixRicosViewerNext.js.map